export const title = 'Configuración de packs';
export const dailyCapacity = 'Capacidad diaria de visitas';
export const subtitle = 'Entradas';
export const createButton = 'Crear nuevo pack';
export const editButton = 'Editar';
export const editTitle = 'Editar pack';
export const uploadImages = 'Agregar imágenes';
